import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24FileG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M13.506 3c-2.114 0-3.804 1.837-3.914 4.11l-.006.236v8.93c0 1.384 1.02 2.54 2.327 2.54 1.247 0 2.233-1.054 2.32-2.353l.006-.187v-8.49a.733.733 0 0 0-1.456-.119l-.01.12v8.489c0 .612-.407 1.073-.86 1.073-.419 0-.798-.393-.854-.935l-.007-.138v-8.93c0-1.609 1.12-2.88 2.454-2.88 1.275 0 2.355 1.163 2.447 2.673l.006.207v8.034c0 2.608-1.833 4.686-4.046 4.686-2.142 0-3.928-1.947-4.041-4.435l-.006-.25V7.785a.733.733 0 0 0-1.456-.119l-.01.12v7.593c0 3.379 2.446 6.152 5.513 6.152 2.984 0 5.38-2.625 5.507-5.88l.005-.272V7.346c0-2.38-1.732-4.346-3.919-4.346"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24FileG$1 = Svg24FileG;

export { Svg24FileG$1 as default };
